import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function HelpListOverview(props) {
    //console.debug('RTS Break HelpListOverview');

    return (
        <Box>
            <Typography>
                The New User Requests page allows you to request the addition of new licnesed users for your 
                organization.  Once a request is created an Administrator has the ability to import the request and 
                create the user.
            </Typography>
            <Typography sx={{mt:1}}>
                The list of New User Requests presented below can be filtered and exported using the toolbar located
                at the top of the list.
            </Typography>            
            <Typography sx={{mt:1}}>
                In addition to the toolbar each column in the list can be manipulated using the menu that appears when you 
                hover over the column header text.
            </Typography>            
            <Typography sx={{mt:1}}>
                A user can remove an existing New User Request by clicking on the red X icon in the far right column of the 
                list or create a new reqest by clicking on the New Request button in the upper right hand corner.
            </Typography>            
        </Box>
    );

}
